



















import { Vue, Component, Prop } from 'vue-property-decorator'
import { Button } from '@alpha/ink'

@Component({
  components: {
    Button
  }
})
export default class ConfirmExitPopup extends Vue {
  @Prop({ required: true }) confirmationTitle!: string
  @Prop({ required: true }) confirmationText!: string
  @Prop({ required: true }) continueButtonText!: string
  @Prop({ required: true }) exitButtonText!: string
  @Prop({ default: true }) setPositionsToZero!: string

  @Prop({ required: true }) continueAction!: () => null
  @Prop({ required: true }) exitAction!: () => null
}
